import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { Szme004aRequest, Szme004aResponse, SZME004AService } from 'sg-api';
import { SgkbConstains } from '../../../../sg-kb-shared/sg-kb-constans';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkb122dSzme004aService {
  /** 請求先・請求情報取得結果のSubject */
  private _commonAceptSearchResult$ = new Subject<Szme004aResponse>();

  /**
  * 請求先・請求情報取得結果のobservable提供
  *
  * @readonly
  * @memberof UsedSgkb122dSzme004aService
  */
  get valueChanges() {
    return this._commonAceptSearchResult$.asObservable();
  }

  /**
   * コンストラクタ
   * @param {SZME004AService} SZME004AService
   * @param {ApiCommonService} apiCommonService
   * @memberof UsedSgkb122dSzme004aService
   */
  constructor(
    private sZME004AService: SZME004AService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig
  ) { }

  /**
   * 請求先・請求情報取得API呼び出し
   * @param {*} value
   * @return {*}  {Observable<Szme004aResponse>}
   * @memberof UsedSgkb122dSzme004aService
   */
  searchContractor(value: Szme004aRequest): Observable<Szme004aResponse> {
    // 検索条件を保存
    return this.sZME004AService.c17RSZME004APost(<Szme004aRequest>this.apiCommonService.setRequestCommon(value), 'response')
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkErrorNoSearchData(response);
          this.apiCommonService.checkError(response);

          this._commonAceptSearchResult$.next(response.body);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, SgkbConstains.MESSAGE.ID_SGKB,
            SgkbConstains.MESSAGE.APINAME_SZME004A);
          return throwError(err.message);
        })
      );
  }
}
